import React, { useState } from 'react';
import { Play } from 'lucide-react';

interface YouTubeFacadeProps {
  videoId: string;
  title: string;
  poster: string;
}

// Shows a poster image and only loads the (heavy) YouTube player after the visitor clicks play.
export const YouTubeFacade: React.FC<YouTubeFacadeProps> = ({ videoId, title, poster }) => {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&color=white`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        className="w-full h-full border-0"
      />
    );
  }

  return (
    <button
      type="button"
      onClick={() => setPlaying(true)}
      className="relative w-full h-full group"
      aria-label={`Play video: ${title}`}
    >
      <img src={poster} alt="" loading="lazy" decoding="async" width={800} height={450} className="w-full h-full object-cover" />
      <span className="absolute inset-0 bg-black/30 group-hover:bg-black/20 transition-colors" />
      <span className="absolute inset-0 flex items-center justify-center">
        <span className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-rose-600 group-hover:bg-rose-500 group-hover:scale-110 transition-all flex items-center justify-center shadow-2xl">
          <Play className="h-8 w-8 md:h-10 md:w-10 text-white ml-1" fill="currentColor" />
        </span>
      </span>
    </button>
  );
};
